module.exports = __webpack_public_path__ + "static/media/get-recommendations-mobile-en.36cc98f3.png";